<ng-template #dynamicComponent></ng-template>